<section style="justify-content: flex-start">
   <h4 class="bold w-87">User panel</h4>
   <main style="width: 100%">
      <div class="cards">
         <div
            routerLink="academic-units-professors"
            routerLinkActive="active"
            class="shadowBorder"
         >
            <div>Professors</div>
         </div>
         <div
            routerLink="academic-units-students"
            routerLinkActive="active"
            class="shadowBorder"
         >
            <div>Students</div>
         </div>
      </div>

      <div>
         <router-outlet></router-outlet>
      </div>
   </main>
</section>
